import React from "react";
import LawFirmBondsPage from "./Law Firm User/components/LawFirmBondsPage";
import { LAW_FIRM_BONDS_MODES } from "./Law Firm User/helpers/lawFirmBondsPageConfig";

/** Underwriting team member bond archives — implemented via {@link ./Law Firm User/components/LawFirmBondsPage.jsx} team-member mode. */
export default function ApproveBondsTeamMember() {
  return <LawFirmBondsPage mode={LAW_FIRM_BONDS_MODES.TEAM_MEMBER} />;
}
